export default __webpack_public_path__ + "static/media/innovation.1cea88d0.jpg";